import { Typography } from "@maxhub/max-ui"

export const TypographyLabelExample = {
    title: 'Typography.Label',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Hello world',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
        {
            name: 'variant',
            label: 'variant',
            type: 'enum',
            tsType: ['"medium"', '"large"', '"custom"', '"large-strong"', '"medium-strong"', '"small"', '"small-strong"'],
            default: 'large',
            options: ['medium', 'large', 'custom', 'large-strong', 'medium-strong', 'small', 'small-strong'],
        },
    ],

    Preview({ props }){
        const labelProps = {
            ...(props.variant ? { variant: props.variant } : {}),
        }

        return (
            <Typography.Label {...labelProps}>
                {props.children}
            </Typography.Label>
        )
    },

    getCode(props){
        return `<Typography.Label${props.variant !== 'large' ? `\n  variant="${props.variant}"` : ''}>
  ${props.children}
</Typography.Label>`
    }

}